<template>
  <modal name="modalChangeEmailTemplate" class="common-card modal-change-email-template" :class="{}" :height="'auto'" :width="600" @before-open="beforeOpen" @before-close="beforeClose">
    <div class="modal-close-img" @click="hideModal()">
      <div class="icon-close"></div>
    </div>
    <div class="modal-header">
      <div class="modal-header-text h1-text">
        <span>CHANGE TEMPLATE</span>
      </div>
    </div>
    <div class="modal-body body-text">
      Changing your email template will erase any changs you have made. Are you sure you want to change your email template?
    </div>
    <div class="modal-footer group-btn">
      <b-button v-if="modalData.btnLeft != ''" class="modal-btn-left ap-btn secondary" @click="hideModal()">
        {{ modalData.btnLeft }}
      </b-button>
      <b-button v-if="modalData.btnRight != ''" class="modal-btn-right ap-btn primary" @click="btnAction()">
        {{ modalData.btnRight }}
      </b-button>
    </div>
  </modal>
</template>

<script>
import consts from '../../_consts';
import { mapActions } from 'vuex';

export default {
  name: '',
  components: {
  },
  data () {
    return {
      actionTypes: consts.modalAction,
      modalData: {},
      actionData: {},
      isCancel: false,
      modalBodies: consts.modalBodies
    }
  },
  methods: {
    hideModal () {
      this.$emit('CLOSE_MODAL_CHANGE_TEMPLATE_ACTION', false);
      this.$modal.hide('modalChangeEmailTemplate');
    },
    beforeOpen (event) {
      this.modalData = consts.mappingModalActionToModalData[event.params.action];
      this.actionData = event.params.data;
    },
    async btnAction () {
      this.$modal.hide('modalChangeEmailTemplate');
      this.$emit('CLOSE_MODAL_CHANGE_TEMPLATE_ACTION', true);
    },
    ...mapActions({
    }),
    beforeClose () {
    }
  },
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// ModalChangeEmailTemplate.vue?5e36434d